import { CdkStepHeader } from '@angular/cdk/stepper';
import { ThemePalette } from '@angular/material/core';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { SutStepLabelDirective } from './step-label';
import { NavStepHeaderStore, StepState } from '../../modules/nav-stepper/nav-step-header.store';
import { GqlSeverity } from '../../graphql/base-types.graphql';
import { NgClass, NgSwitch, NgSwitchCase, AsyncPipe } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'sut-nav-step-header', // eslint-disable-line @angular-eslint/component-selector
  templateUrl: './nav-step-header.component.html',
  styleUrls: ['./nav-step-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [NavStepHeaderStore],
  imports: [NgClass, NgSwitch, NgSwitchCase, MatTooltip, MatIcon, AsyncPipe],
})
export class SutNavStepHeaderComponent extends CdkStepHeader implements OnChanges {
  @Input() color: ThemePalette = 'primary';
  @HostBinding('class') get classColor() {
    return `mat-${this.color}`;
  }

  StepState = StepState;

  @Input() label: SutStepLabelDirective | string;
  @Input() index: number;
  @Input() selected: boolean;
  @Input() active: boolean;
  @Input() optional: boolean;
  @Input() completed: boolean;
  @Input() hasError: boolean;
  @Input() errorMessage: string;
  @Input() severity: GqlSeverity;

  constructor(
    elementRef: ElementRef<HTMLElement>,
    public store: NavStepHeaderStore,
  ) {
    super(elementRef);
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('completed' in changes) {
      this.store.setCompleted(this.completed);
    }
    if ('hasError' in changes) {
      if (changes.severity?.currentValue === GqlSeverity.Warning) {
        this.store.setWarning(this.hasError);
      } else {
        this.store.setHasError(this.hasError);
      }
    }
  }

  _stringLabel(): string | null {
    return this.label instanceof SutStepLabelDirective ? null : this.label;
  }

  _templateLabel(): SutStepLabelDirective | null {
    return this.label instanceof SutStepLabelDirective ? this.label : null;
  }
}
